import React from 'react';
import { Card, Tabs } from 'antd';
import { useData } from '../../contexts/DataContext';

const SiteDetails = () => {
  const { sites, selectedSites } = useData();

  if (!selectedSites) {
    return <div className="flex items-center justify-center h-full">No site data available</div>;
  }

  const selectedSitesList = Object.keys(selectedSites).filter(id => selectedSites[id]);
  const selectedSitesData = sites.filter(site => selectedSitesList.includes(site.id));

  if (selectedSitesData.length === 0) {
    return <div className="flex items-center justify-center h-full">No site selected</div>;
  }

  const items = selectedSitesData.map(site => ({
    key: site.id,
    label: site.name,
    children: (
      <div className="p-4 space-y-4">
        <Card title="General Information">
          <p><strong>Name:</strong> {site.name}</p>
          <p><strong>ID:</strong> {site.id}</p>
          <p><strong>Location:</strong> {site.Location}</p>
          <p><strong>Time Zone:</strong> {site.TimeZone}</p>
        </Card>
        
        <Card title="Coordinates">
          <p><strong>Latitude:</strong> {site.latitude}</p>
          <p><strong>Longitude:</strong> {site.longitude}</p>
        </Card>

        <Card title="Measurements">
          <p><strong>Types:</strong> {site.typeOfMeasurements}</p>
          <p><strong>Unit 1:</strong> {site.unit1}</p>
          <p><strong>Unit 2:</strong> {site.unit2}</p>
        </Card>
      </div>
    ),
  }));

  return (
    <Tabs 
      type="card" 
      className="h-full"
      items={items}
    />
  );
};

export default SiteDetails;